<template>
    <v-row>
      <v-col cols="12" style="padding:0px !important;">
        <v-carousel
              class="hidden-sm-and-down"
              :show-arrows="false"
              hide-delimiters
              interval="12000"
              height="500"
          >
              <v-carousel-item
              v-for="(item, i) in slides"
              :key="i"
              :src="item.src"
              reverse-transition="fade-transition"
              transition="fade-transition"
              >
              <div class="overlay">
                  <v-row class="fill-height" style="padding-top:150px;">
                  <v-col cols="11" offset="1" style="color:#ffffff;">
                      <v-layout wrap class="text-h4" style="color:#ffffff;">
                      <b>{{ item.title }}</b>
                      </v-layout>
                      <p class="ma-5" style="font-size: 18px;">
                      {{ item.text }}
                      </p>
                      <v-layout wrap>
                      <v-btn rounded color="#72bd61" dark>{{ item.btnText }}</v-btn>
                      </v-layout>
                  </v-col>
                  </v-row>
              </div>
              </v-carousel-item>
          
        </v-carousel>
        <v-carousel
              class="hidden-md-and-up"
              cycle
              :show-arrows="false"
              hide-delimiters
              height="200px"
              interval="10000"
          >
              <v-carousel-item
              v-for="(item, i) in slides"
              :key="i"
              :src="item.src"
              transition="fade"
              reverse-transition="fade"
              >
              <div class="overlay">
                  <v-row class="fill-height pt-5">
                  <v-col cols="8" offset="1" style="color:#ffffff;">
                      <v-layout wrap class="text-h6" style="color:#ffffff;">
                      {{ item.title }}
                      </v-layout>
                      <p>
                      {{ item.text }}
                      </p>
                      <v-layout wrap>
                      <v-btn rounded color="#72bd61" dark small>{{
                          item.btnText
                      }}</v-btn>
                      </v-layout>
                  </v-col>
                  </v-row>
              </div>
              </v-carousel-item>
        </v-carousel>
  
        <v-container fluid >
          <v-layout wrap>
                <v-col cols="12" align="center">
                  <h2><b>Welcome to qikPharma.com</b></h2>
                </v-col>
                <v-col cols="12">
                    <p>
                        qikPharma (“us”, “we”, or “our”) operates www.qikPharma.com (hereinafter referred to as “Service”).
                        Our Privacy Policy governs your visit to www.qikPharma.com, and explains how we collect, safeguard and disclose information that results from your use of our Service.
                        We use your data to provide and improve Service to you and others. By using Service, you agree to the collection and use of information in accordance with this policy. 
                        Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
                    </p>

                    <p>Our Terms and Conditions (“Terms”) govern all use of our Service and together with the Privacy Policy constitutes your agreement with us (“agreement”).</p>

                    <h4><b>Definitions</b></h4>
                    <p>
                        SERVICE means the www.qikPharma.com website, mobile application and other products offered and operated by qikPharma.
                        PERSONAL DATA means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).
                    </p>
                    <p>USAGE DATA is data collected automatically either generated by the use of Service or from Service infrastructure itself (for example, the duration of a page visit).</p>

                    <p>COOKIES are small files stored on your device (computer or mobile device).</p>

                    <p>DATA CONTROLLER means a natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal data are, 
                        or are to be, processed. For the purpose of this Privacy Policy, we are a Data Controller of your data.
                    </p>

                    <p>DATA PROCESSORS (OR SERVICE PROVIDERS) means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers in order to process your data more effectively.</p>
                    <p>DATA SUBJECT is any living individual who is the subject of Personal Data.</p>
                    <p>THE USER is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.</p>

                    <h4><b>Information Collection and Use</b></h4>
                    <p>
                        We collect several different types of information for various purposes to provide and improve our Service to you.
                    </p>

                    <h4><b>Types of Data Collected</b></h4>
                    <p>
                        Personal Data <br>
                        While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“Personal Data”). Personally identifiable information may include, but is not limited to:
                        <ol>
                            <li>Email address</li>
                            <li>First name and last name</li>
                            <li>Phone number</li>
                            <li>Address, Country, State, Province, ZIP/Postal code, City</li>
                            <li>Cookies and Usage Data</li>
                        </ol>
                        We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link if available at the time your wish to opt out.
                    </p>

                    <h4><b>Usage Data</b></h4>
                    <p>We may also collect information that your browser sends whenever you visit our Service or when you access Service by or through any device (“Usage Data”).</p>
                    <p>This Usage Data may include information such as your computer’s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit,
                         the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
                    </p>
                    <p>
                        When you access Service with a device, this Usage Data may include information such as the type of device you use, your device unique ID, the IP address of your device, your device operating system, the type of Internet browser you use, unique device identifiers and other diagnostic data.
                    </p>

                    <h4><b>Location Data</b></h4>
                    <p>We may use and store information about your location if you give us permission to do so (“Location Data”). We use this data to provide features of our Service, to improve and customize our Service.</p>
                    <p>You can enable or disable location services when you use our Service at any time by way of your device settings</p>

                    <h4><b>Tracking Cookies Data</b></h4>
                    <p>We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.</p>
                    <p>
                        Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. 
                        Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyse our Service.
                    </p>
                    <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</p>
                    <p>
                        Examples of Cookies we use:
                        <ol>
                            <li>Session Cookies: We use Session Cookies to operate our Service.</li>
                            <li>Preference Cookies: We use Preference Cookies to remember your preferences and various</li>
                            <li>Security Cookies: We use Security Cookies for security purposes.</li>
                            <li>Advertising Cookies: Advertising Cookies are used to serve you with advertisements that may be relevant to you and your interests.</li>
                        </ol>
                    </p>

                    <h3><b>Other Data</b></h3>
                    <p>While using our Service, we may also collect the following information: sex, age, date of birth, place of birth, passport details, citizenship, 
                        registration at place of residence and actual address, telephone number (work, mobile), location and other data.</p>

                    <h3><b>Use of Data</b></h3>
                    <p>qikPharma uses the collected data for various purposes:</p>
                        <ol>
                            <li>to provide and maintain our Service;</li>
                            <li>to notify you about changes to our Service;</li>
                            <li>to allow you to participate in interactive features of our Service when you choose to do so;</li>
                            <li>to provide customer support;</li>
                            <li>to gather analysis or valuable information so that we can improve our Service;</li>
                            <li>to monitor the usage of our Service;</li>
                            <li>to detect, prevent and address technical issues;</li>
                            <li>to fulfil any other purpose for which you provide it;</li>
                            <li>to carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection;</li>
                            <li>to provide you with notices about your account and/or subscription, including expiration and renewal notices, email-instructions, etc.;</li>
                            <li>to provide you with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information;</li>
                            <li>in any other way we may describe when you provide the information;</li>
                            <li>for any other purpose with your consent.</li>
                        </ol>

                    <h3><b>Retention of Data</b></h3>
                    <p>
                        We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, 
                        if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
                    </p>
                    <p>
                        We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of our Service, 
                        or we are legally obligated to retain this data for longer time periods.
                    </p>

                    <h3><b>Transfer of Data</b></h3>
                    <p>
                        Your information, including Personal Data, may be transferred to – and maintained on – computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.
                    </p>
                    <p>
                        If you are located outside Nigeria and choose to provide information to us, please note that we transfer the data, including Personal Data, to Nigeria and process it there.
                        Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
                        qikPharma will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organisation or a country unless there are adequate controls in place including the security of your data and other personal information.
                    </p>

                    <h3><b>Disclosure of Data</b></h3>
                    <p>
                        We may disclose personal information that we collect, or you provide:
                        <ol>
                            <li>Disclosure for Law Enforcement: Under certain circumstances, we may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities.</li>
                            
                            <li>Business Transaction: If we or our subsidiaries are involved in a merger, acquisition or asset sale, your Personal Data may be transferred.</li>
                            <li>Other cases. We may disclose your information also:
                                <ol>
                                    <li>to our subsidiaries and affiliates;</li>
                                    <li>to contractors, service providers, and other third parties we use to support our business;</li>
                                    <li>to fulfil the purpose for which you provide it;</li>
                                    <li>for the purpose of including your company’s logo on our website;</li>
                                    <li>for any other purpose disclosed by us when you provide the information;</li>
                                    <li>with your consent in any other cases;</li>
                                    <li>If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of the Company, our customers, or others.</li>
                                </ol>
                            </li>
                        </ol>
                    </p>

                    <h3><b>Security of Data</b></h3>
                    <p>The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p>

                    <h3><b>Service Providers</b></h3>
                    <p>We may employ third party companies and individuals to facilitate our Service (“Service Providers”), provide Service on our behalf, perform Service-related services or assist us in analysing how our Service is used.</p>
                    <p>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>
                
                    <h3><b>Analytics</b></h3>
                    <p>We may use third-party Service Providers to monitor and analyse the use of our Service.</p>

                    <h3><b>CI/CD tools</b></h3>
                    <p>We may use third-party Service Providers to automate the development process of our Service.</p>

                    <h3><b>Advertising</b></h3>
                    <p>We may use third-party Service Providers to show advertisements to you to help support and maintain our Service.</p>

                    <h3><b>Behavioural Remarketing</b></h3>
                    <p>We may use remarketing services to advertise on third party websites to you after you visited our Service. We and our third-party vendors use cookies to inform, optimise and serve ads based on your past visits to our Service.</p>

                    <h3><b>Payments</b></h3>
                    <p>
                        We may provide paid products and/or services within Service. In that case, we use third-party services for payment processing (e.g. payment processors).
                        We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, 
                        which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.
                    </p>

                    <h3><b>Links to Other Sites</b></h3>
                    <p>Our Service may contain links to other sites that are not operated by us. If you click a third party link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of every site you visit.</p>
                    <p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>

                    <h3><b>Children’s Privacy</b></h3>
                    <p>Our Services are not intended for use by children under the age of 18 (“Child” or “Children”).</p>
                    <p>We do not knowingly collect personally identifiable information from Children under 18 unless otherwise stated by us in subsequent activities.</p>

                    <h3><b>Changes to This Privacy Policy</b></h3>
                    <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
                    <p>We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update “effective date” at the top of this Privacy Policy.</p>
                    <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>

                    <h3><b>Contact Us</b></h3>
                    <p>If you have any questions about this Privacy Policy, please contact us by email: info@qikPharma.com</p>

                </v-col>
          </v-layout>
  
          <v-layout wrap>
              <v-col cols="12" md="4" offset-md="2" align="left">
                      <v-icon
                          style="color:#7CBF46 !important; font-size:70px !important"
                          dark
                          >mdi-basket-fill
                      </v-icon> <span style="font-size:25px !important"><b>Product Quality</b></span>
              </v-col>
               <v-col cols="12" md="5" offset-md="1" align="left">
                      <v-icon
                          style="color:#7CBF46 !important; font-size:70px !important"
                          dark
                          >mdi-timer-check
                      </v-icon> <span style="font-size:25px !important"><b>On-Time Delievery</b></span>
              </v-col>
          </v-layout>
  
  
  
        </v-container>
  
      
      </v-col>
    </v-row>
  </template>
  
  <script>
  export default {
    name: "PrivacyPolicy",
  
    data: () => ({
        slides: [
          {
            src: "slider/Slider-01.png",
            title: "Privacy Policy",
            text: "Protect Your qikPharma Orders.",
            btnText: "Learn How it Works",
            link: "#",
          },
        ],
    })
  };
  </script>
  
  <style scoped>
  .overlay {
    background-color: rgba(0, 0, 0, 0.6);
    height: 100%;
  }
  
  .box1 {
    background: linear-gradient(192.88deg, #111212 43.53%, #72bd61 90.69%);
    border-radius: 10px;
    color: #ffffff;
  }
  
  .box2 {
    background: rgba(0, 0, 0, 0.07);
    border-radius: 10px;
    color: #171a17;
  }
  
  .barcodeTitle {
    color: #000000;
    font-size: 16px;
    text-align: center;
  }
  
  .barcodeText {
    color: #c2c2c2;
    font-size: 12px;
    margin-top: 15px;
    text-align: center;
  }
  
  .centerImg {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100px;
  }
  
  p {
    line-height: 1.6;
  }
  
  li {
    line-height: 1.6;
  }
  
  </style>
  